'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateCacheEntry;

var _felaUtils = require('fela-utils');

function generateCacheEntry(type, className, property, value) {
  var pseudo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var media = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var support = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  return {
    type: type,
    className: className,
    selector: (0, _felaUtils.generateCSSSelector)(className, pseudo),
    declaration: property + ':' + value,
    pseudo: pseudo,
    media: media,
    support: support
  };
}